function round(num) {
  return Number(num.toFixed());
}

export default function useCalculation(calculations) {
  /*
    amount
    discount
    discount_tax
    items_amount
    items_tax
    fee
    fee_tax
    sales
    tax
  */

  if (calculations && calculations.original_amount) {
    let fee = round(calculations.fee / 1.05);
    let discount = round(calculations.discount_amount / 1.05);
    let items_tax =
      calculations.items_amount - calculations.items_amount_before_tax;
    let _calculations = {
      amount: calculations.amount,
      discount: discount * -1,
      discount_tax: (calculations.discount_amount - discount) * -1,
      items_amount: calculations.items_amount_before_tax,
      items_tax: items_tax,
      fee: fee,
      fee_tax: calculations.fee - fee,
      sales: fee - discount + calculations.items_amount_before_tax,
      tax:
        calculations.fee -
        fee +
        items_tax -
        (calculations.discount_amount - discount),
    };
    return _calculations;
  }
  return calculations;
}
